import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { ImageCropperModule } from 'ngx-image-cropper';

import { CropPhotoPage } from './crop-photo.page';
import { SquadCastComponentsModule } from '../../components/squadcast.components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImageCropperModule,
    RouterModule.forChild([
      {
        path: '',
        component: CropPhotoPage,
      },
    ]),
    SquadCastComponentsModule,
  ],
  declarations: [CropPhotoPage],
})
export class CropPhotoModule {}
